// libraries
import { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { notification, Table } from 'antd';
import { CameraOutlined, CheckOutlined } from '@ant-design/icons';

import moment from 'moment';

import { txt } from '../../../../../locales/i18n';
import * as UserService from '../../../../../services/bb-api/user';

export function UserPostsTab(): JSX.Element {
	const [posts, setPosts] = useState<Record<string, any>[]>([]);
	const [loading, setLoading] = useState(true);

	const history = useHistory();
	const { id: userId } = useParams<Record<string, any>>();

	const handlePostsCallback = useCallback(getPostsCallback, [setPosts, setLoading, userId]);

	useEffect(() => {
		handlePostsCallback();
	}, [handlePostsCallback]);

	async function getPostsCallback(): Promise<void> {
		setLoading(true);

		try {
			const posts: Record<string, any>[] = await UserService.getPosts(userId);
			setPosts(posts);
		} catch (error) {
			setPosts([]);

			notification.error({
				message: (error as Error).name,
				description: (error as Error).message,
				duration: null,
			});
		}

		setLoading(false);
	}

	function formatDate(date: Date): string {
		const format: string = 'ddd DD/MM-YY HH:mm';
		const dateString: string = moment(date).format(format);
		return dateString;
	}

	function renderCheckmark(value: any): JSX.Element | null {
		if (Boolean(value) === false) {
			return null;
		}

		return <CheckOutlined />;
	}

	return (
		<Table
			rowKey="id"
			loading={loading}
			dataSource={posts}
			pagination={{ position: [], pageSize: 200 }}
			scroll={{ x: 1300 }}
			sticky
			onRow={(post: Record<string, any>) => ({
				onClick: () => history.push(`/posts/${post.id}`),
			})}
		>
			<Table.Column dataIndex="id" title="ID" width="6rem" />
			<Table.Column dataIndex="title" title={txt('global.title')} ellipsis />
			<Table.Column
				dataIndex="approved"
				title={<CheckOutlined />}
				render={renderCheckmark}
				width="4rem"
				align="center"
			/>
			<Table.Column
				dataIndex="img_id"
				title={<CameraOutlined />}
				render={renderCheckmark}
				width="4rem"
				align="center"
			/>
			<Table.Column dataIndex="conversations" title={txt('global.conversations')} />
			<Table.Column dataIndex="messages" title={txt('global.messages')} />
			<Table.Column dataIndex="universe" title={txt('global.universe')} />
			<Table.Column dataIndex="created" title={txt('global.created')} render={formatDate} width="12rem" />
		</Table>
	);
}
